import { TypeofExpr } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import * as saveAs from 'file-saver';
import * as moment from 'moment';
import { LocalDataSource } from 'ng2-smart-table';
import { mongoId } from '../../../@core/common/global';
import { ApiService } from '../../../@core/service/api.service';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { ActivityContentModel, ActivityModel, ContactModel, EActivityContentType, EContactFieldType, EContactType } from '../../../@models';
import { DownloadConfig } from '../../erp/document/document-printer/document-printer.component';

@Component({
  selector: 'activity-statistics',
  templateUrl: './activity-statistics.component.html',
  styleUrls: ['./activity-statistics.component.scss']
})
export class ActivityStatisticsComponent implements OnInit {

  settings = {
    actions: false,
    columns: {
      // baseProduct: {
      //   title: 'Base Product',
      //   width: '10rem',
      //   valuePrepareFunction: (val) => val ? `${val.code} - ${val.name} [${val.trial}]` : '',
      // },
      // unit: {
      //   title: 'Unit',
      //   width: '5rem',
      // },
      documentNumber: {
        title: 'Document #',
        // width: '7.5rem',
      },
      dateOfSave: {
        title: 'Date of Save',
        // width: '7.5rem',
      },
      dateOfVisit: {
        title: 'Date of Visit',
        // width: '7.5rem',
      },
      typeOfActitivty: {
        title: 'Type of Activity',
        // width: '8rem',
      },
      country: {
        title: 'Country',
        // width: '8rem',
      },
      region: {
        title: 'Region',
        // width: '8rem',
      },
      manager: {
        title: 'Sales Manager',
        // width: '10rem',
      },
      customer: {
        title: 'Customer',
        // width: '10rem',
      },
      location: {
        title: 'Location',
        // width: '10rem',
      },
      summary: {
        title: 'Summary',
      },
      participant: {
        title: 'NRK Participant',
        // width: '25rem',
      },
    },
    filter: {
      inputClass: 'filter',
    },
  };

  source: LocalDataSource;

  loading = false;

  constructor(private api: ApiService, private data: SharedDataService) { }

  async ngOnInit() {

    this.source = new LocalDataSource();
    this.loading = true;

    await this.data.loadContacts();
    await this.data.loadRegions();

    const data: any[] = [];
    this.api.reloadActivities(true).subscribe((activities) => {
      // console.log('activities: ', activities);
      // this.activities = activities
      for (const activity of activities) {
        const manager = this.data.contacts.find(f => mongoId(f) === activity.business?.manager);
        const contacts = activity.business?.contacts?.map(m => this.data.contacts.find(f => mongoId(f) === mongoId(m))) as ContactModel[];
        const general = contacts?.find(f => +f.type === EContactType.General);
        const country = general?.fields.find(f => +f.type === EContactFieldType.Country);
  
        const row: any = {}
        row.documentNumber = this.getVersionCode(activity);
        row.dateOfSave = ((activity as any).updatedAt as string).replace(/T.*/,'');
        row.dateOfVisit = activity.date?.replace(/T.*/,'');;
        row.typeOfActitivty = EActivityContentType[activity.content.type];
        row.country = country?.value || '';
        row.region = this.data.regions.find(f => mongoId(f) === mongoId(activity.business?.region))?.name || '';
        row.manager = manager?.title || '';
        row.customer = activity.business?.name;
        row.location = activity.location;
        row.summary = activity.title;
        row.participant = '';
        let participants  = 0;
        activity.participants?.forEach(p => {
          if (/^NRK/.test(p.name)) {
            const res = Object.assign({}, row);
            res.participant = p.name;
            data.push(res);
            participants++;
          }
        })
        if (!participants) data.push(row);
      }
      this.source.load(data);
      this.loading = false;
    })

  }

  async downloadXlsx() {

    const conf = new DownloadConfig();
    const cols = Object.keys(this.settings.columns);
    conf.table = JSON.stringify({
      header: cols.map(m => ({ name: m, header: this.settings.columns[m].title })),
      table: (await this.source.getFilteredAndSorted()).map(m => Object.values(m)),
    })
    console.log('activity statistics: conf:', conf);
    this.api.getDocumentFile('/api/v1/document_report/xls', conf).subscribe(async res => {
      saveAs(res, (new Date()).toISOString().replace(/\d\d(\d\d)-(\d\d)-(\d\d)/, '$1$2$3') + '_ActivityStatistics.xls')
    });
  }

  getVersionCode(item: ActivityModel) {
    const date = moment(item.date).utc().format('YYMMDD');
    const company = 'NRKA'; // item.business.name;
    const name = item.owner.short;
    const seq = (item.seq || 0).toString().padStart(4, '0');
    const v = ((item.version || 0) /* + (item.draft ? 1 : 0) */).toString().padStart(2, '0');
    const type = ActivityContentModel.getShort(item.content.type);
    return `${type}${name}${company}${seq}-VS${v}${item.draft ? '-DRAFT' : ''}`;
  }
}
